import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { OCCUPANCY_CARD_TYPE } from 'src/features/cards/types';
import { cardMessages } from 'src/features/cards/utils/messages';
import { OCCUPANCY_CARD_TYPE_MAP } from 'src/features/statistics/utils';
import { Button } from 'src/registry/ui/Button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuTrigger,
} from 'src/registry/ui/DropdownMenu';

type StatisticsDropdownProps = {
    selectedCardType: OCCUPANCY_CARD_TYPE;
    setSelectedCardType: (cardType: OCCUPANCY_CARD_TYPE) => void;
};
export default function StatisticsCardTypeDropdown(props: StatisticsDropdownProps) {
    const { formatMessage } = useIntl();
    const { selectedCardType, setSelectedCardType } = props;
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="xsIcon">
                    <FontAwesomeIcon className="text-primary-700" icon={faFilter} />
                    <span className="xs:block hidden">{formatMessage(cardMessages.cardType)}</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-56">
                <DropdownMenuGroup>
                    {Object.values(OCCUPANCY_CARD_TYPE).map((cardType: OCCUPANCY_CARD_TYPE) => {
                        return (
                            <DropdownMenuCheckboxItem
                                key={cardType}
                                checked={selectedCardType === cardType}
                                onSelect={(e) => e.preventDefault()}
                                onCheckedChange={(value) => {
                                    if (!value) return;
                                    setSelectedCardType(cardType);
                                }}
                            >
                                {formatMessage(OCCUPANCY_CARD_TYPE_MAP[cardType])}
                            </DropdownMenuCheckboxItem>
                        );
                    })}
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
